import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  GetPatientAllPaymentProjectionCardStatusEnum,
  GetPatientAllPaymentProjectionPaymentModeEnum,
  GetPatientAllPaymentProjectionTypeOfPaymentEnum,
  PatientPaymentControllerApi,
} from "../../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getXtenantId,
  useBaseContent,
} from "../../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  paymentMode: GetPatientAllPaymentProjectionPaymentModeEnum;
  typeOfPayment: GetPatientAllPaymentProjectionTypeOfPaymentEnum;
  archived?: boolean;
  cardStatus?: GetPatientAllPaymentProjectionCardStatusEnum;
  patientUuid: string;
  enabled?: boolean;
}

/**
 *
 * @author Rajkumar Rathod
 */
export function useGetPatientCards({
  pagination,
  paymentMode,
  typeOfPayment,
  archived = false,
  cardStatus,
  patientUuid,
  enabled = true,
}: Props): useBaseContent<any> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  return useQuery({
    queryKey: [
      "get-patient-cards",
      pageIndex,
      pagination.pageSize,
      paymentMode,
      typeOfPayment,
      archived,
      cardStatus,
      patientUuid,
    ],
    refetchOnWindowFocus: false,
    enabled: enabled,
    queryFn: async () =>
      new PatientPaymentControllerApi(getConfigObject())
        .getPatientAllPaymentProjection(
          pageIndex,
          pagination.pageSize,
          paymentMode,
          typeOfPayment,
          patientUuid,
          archived,
          cardStatus,
          getXtenantId() //xTENANTID
        )
        .then((res) => res?.data),
  });
}
